import { useEffect, useState } from 'react';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';

function useDocumentsSpecifiques(
  lastModificationDate: number | undefined,
): DocumentSpecifiqueDto[] {
  const { DocumentSpecifiqueControllerApi: api } = useApi();
  const behaviourOnError = useHandleBackErrors();

  const [items, setItems] = useState<DocumentSpecifiqueDto[]>();

  useEffect(() => {
    api
      .getDocumentsSpecifiquesUsingGET()
      .then(setItems)
      .catch((err: Response) => {
        behaviourOnError(err);
      });
  }, [lastModificationDate]);

  return items || [];
}

export default useDocumentsSpecifiques;
